import script from "./IndexLoggedIn.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexLoggedIn.vue?vue&type=script&setup=true&lang=js"

import "./IndexLoggedIn.vue?vue&type=style&index=0&id=6a77cabc&lang=css"

export default script